export default __webpack_public_path__ + "static/media/scan-documents.a949921b.svg";